import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The Time Ago component.
 * @element ghs-time-ago
 */
@customElement('ghs-time-ago')
export class GhsTimeAgo extends OutlineElement {
  @property()
  datetime: string;

  // Takes an ISO date string and returns a formatted string of how long ago it was
  timeAgo(isoDateTime: string): string {
    const currentDate: Date = new Date();
    const inputDate: Date = new Date(isoDateTime);

    // Calculate the time difference in milliseconds and convert it
    const timeDifference: number = currentDate.getTime() - inputDate.getTime();
    const seconds: number = Math.abs(timeDifference / 1000);

    // Create an array of time units with their divisors
    const timeUnits: Array<{ unit: string; divisor: number }> = [
      { unit: 'year', divisor: 365 * 24 * 60 * 60 },
      { unit: 'month', divisor: 30 * 24 * 60 * 60 },
      { unit: 'week', divisor: 7 * 24 * 60 * 60 },
      { unit: 'day', divisor: 24 * 60 * 60 },
      { unit: 'hour', divisor: 60 * 60 },
      { unit: 'minute', divisor: 60 },
      { unit: 'second', divisor: 1 },
    ];

    // Return the first matching condition
    for (let i = 0; i < timeUnits.length; i++) {
      const value = Math.floor(seconds / timeUnits[i].divisor);
      if (value > 0) {
        const word = timeDifference > 0 ? 'ago' : 'from now';
        return `${value} ${timeUnits[i].unit}${value > 1 ? 's' : ''} ${word}`;
      }
    }

    // Return an empty string if no condition matches
    return ``;
  }

  render(): TemplateResult {
    return html`
      <time
        aria-label="${this.timeAgo(this.datetime)}"
        datetime="${this.datetime}"
      >
        ${this.timeAgo(this.datetime)}
      </time>
    `;
  }
}
